import {Component, OnInit} from '@angular/core';
import {ConfigService, PersonalConfig, MenuOrientation} from "../config.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Entity} from "../../core/commons/entity";
import {SelectItem} from "primeng/components/common/api";
import { ProfileService } from 'app/profile/service/profile.service';
import { UserPreferences } from 'app/fiscalia/domain/userPreferences';
import { NotificationTopicService } from 'app/home/service/notificationTopic.service';
import { NotificationTopic } from 'app/fiscalia/domain/notificationTopic';
import { GlobalAppService } from 'app/core/commons/global-app.service';
import { MessageSeverity } from 'app/core/commons/message-severity';

@Component({
    selector: 'app-settings',
    templateUrl: './app-settings.component.html',
    styleUrls: ['./app-settings.component.scss']
})
export class AppSettingsComponent implements OnInit {

    configForm: FormGroup;

    layoutModeOptions: any[] = [
        {label: "Horizontal", value: MenuOrientation.HORIZONTAL},
        {label: "Superpuesto", value: MenuOrientation.OVERLAY},
        {label: "Estático", value: MenuOrientation.STATIC}
    ];

    preferences: UserPreferences;
    topics: NotificationTopic[];
    topicsSelected = [];
    loading = true;
    constructor(private configService: ConfigService,
                private fb: FormBuilder,
                private profileService: ProfileService,
                private msgService: GlobalAppService,
                private topicService: NotificationTopicService) {
    }


    ngOnInit() {
        this.topicService.getAll().subscribe(t => {
            this.topics = t;
            console.table(t);
            this.profileService.getUserPreferences().subscribe(p => {
                this.preferences = p;
                console.table(p.suscribedTopics)
                this.topics.forEach(topic => {
                    if(p.suscribedTopics.find(suscribedTopic => suscribedTopic.id === topic.id)){
                        this.topicsSelected.push(true);
                    } else {
                        this.topicsSelected.push(false);
                    }
                });
                this.loading = false;
            })
        });


        let config = this.configService.config;

        this.configForm = this.fb.group({
            layoutCompact: [config.layoutCompact],
            layoutMode: [config.layoutMode],
            profileMode: [config.profileMode],
            rotateMenuButton: [config.rotateMenuButton],
            topbarMenuActive: [config.topbarMenuActive],
            overlayMenuActive: [config.overlayMenuActive],
            staticMenuDesktopInactive: [config.staticMenuDesktopInactive],
            staticMenuMobileActive: [config.staticMenuMobileActive],
        });

        this.configForm.valueChanges
            .do(values => console.log(values))
            .subscribe(value =>
                this.configService.config = this.formValueToEntity(value));
    }

    formValueToEntity(value: any): PersonalConfig {
        value.profileMode = value.profileMode ? 'inline' : '';
        return new PersonalConfig(value);
    }

    onSubmit(event: any) {


        const topicsToSubmit: NotificationTopic[] = [];
        for (let index = 0; index < this.topicsSelected.length; index++) {
            if (this.topicsSelected[index]) {
                topicsToSubmit.push(this.topics[index])
            }
        }


        this.preferences.suscribedTopics = topicsToSubmit;

        console.table(this.preferences.suscribedTopics)

        this.profileService.updateUserPreferences(this.preferences).subscribe(res => {
            this.msgService.sendMsg(MessageSeverity.SUCCESS, "Éxito", "Se ha guardado la configuración exitosamente.")
        }, err => {
            this.msgService.sendMsg(MessageSeverity.ERROR, "Error", "Ha ocurrido un error al guardar la configuración.")
        });

        this.configService.config = this.formValueToEntity(this.configForm.value);
        event.preventDefault();
    }
}


// WEBPACK FOOTER //
// ./src/app/personal-config/app-settings/app-settings.component.ts